module.exports = __webpack_public_path__ + "static/media/logo_fi.c5208b65.svg";